module.exports = __webpack_public_path__ + "img/3.a32dabeb.png";